export enum SocialPlatformEnum {
    // Global – core B2B
    LinkedIn = 1,
    X = 2,              // X (Twitter)
    YouTube = 3,
    Facebook = 4,
    Instagram = 5,
    TikTok = 6,         // Uwaga: duplikat wartości z Instagram
    Reddit = 7,

    // B2B katalogi / review
    Crunchbase = 200,
    Cphi = 201,         // CPHI Online

    // Regionalne B2B
    Xing = 400,         // DACH
    WeChat = 401,       // CN
    Zhihu = 402,        // CN
    Line = 403,         // JP/TW/TH
    KakaoTalk = 404,    // KR
    NaverBlog = 405,    // KR
}

// Etykiety do wyświetlania (odpowiedniki Display(Name = "..."))
export const SocialPlatformLabel: Record<SocialPlatformEnum, string> = {
    [SocialPlatformEnum.LinkedIn]: "LinkedIn",
    [SocialPlatformEnum.X]: "X (Twitter)",
    [SocialPlatformEnum.YouTube]: "YouTube",
    [SocialPlatformEnum.Facebook]: "Facebook",
    [SocialPlatformEnum.Instagram]: "Instagram",
    [SocialPlatformEnum.TikTok]: "TikTok",
    [SocialPlatformEnum.Reddit]: "Reddit",

    [SocialPlatformEnum.Crunchbase]: "Crunchbase",
    [SocialPlatformEnum.Cphi]: "CPHI Online",

    [SocialPlatformEnum.Xing]: "Xing (DACH)",
    [SocialPlatformEnum.WeChat]: "WeChat (CN)",
    [SocialPlatformEnum.Zhihu]: "Zhihu (CN)",
    [SocialPlatformEnum.Line]: "LINE (JP/TW/TH)",
    [SocialPlatformEnum.KakaoTalk]: "KakaoTalk (KR)",
    [SocialPlatformEnum.NaverBlog]: "Naver Blog (KR)",
};

// Opcje np. do MUI <Select/>
export const SOCIAL_PLATFORM_OPTIONS = Object.entries(SocialPlatformEnum)
    .filter(([k, v]) => typeof v === "number") // tylko wartości liczbowe
    .map(([name, value]) => ({
        id: value as unknown as SocialPlatformEnum,
        label: SocialPlatformLabel[value as unknown as SocialPlatformEnum] ?? name,
    }))
    // usuwamy duplikaty po id (zachowaj pierwszy)
    .filter((opt, idx, arr) => arr.findIndex(o => o.id === opt.id) === idx);

// Pomocniczo: type-guard na ID (np. gdy przychodzi liczba z backendu)
export function isSocialPlatformId(x: number): x is SocialPlatformEnum {
    return x in SocialPlatformLabel;
}
